const media = {
  desktop: { minWidth: 800 + 1 },
  mobile: { maxWidth: 800 },
};

export { media };
